module.exports = __webpack_public_path__ + "static/media/author.c4a5f604.jpg";